export interface ChipListItem {
    chipBig: boolean;
    pill?: string;
    role: string;
    name: string;
    styleClass?: string;
    actionCallback: any;
}

export interface BreadcrumbConfig {
    titleSmall: string;
    titleLarge: string;
    desc?: string;
    image?: string;
}
export interface DialogConfig {
    type: DIALOG_TYPE;
    header?: string;
    actions: DialogAction[];
    body?:
        | {
              image?: any;
              description?: string;
          }
        | (
          {
            label: string;
            classes: string;
          }
          | {
            label: string;
            options: object;
            returnValue:string;
          }
        )[]
        | {
              label: string;
              classes: string;
          }[];
}

export interface ButtonConfig {
    label: string;
    hint?: string;
    classes?: string[];
    actionCallback: any;
    disabled?: boolean;
    otherProperties?: any;
}

export enum DIALOG_TYPE {
    OTP = 'OTP',
    IMAGES = 'IMAGES',
    GENERIC = 'GENERIC',
    UPLOAD = 'UPLOAD',
}

export enum APPLICATION_STATUS {
    NEW = 'Έναρξη νέου αιτήματος {{typeSingular2}}. Αναμονή ενεργειών από {{transferringSingular3}} και {{acquiringSingular3}} (εξουσιοδότηση, επιλογή ακινήτου)',
    ACTIVE = 'Σε Εξέλιξη',
    REJECTED = 'Απορρίφθηκε',
    REQUESTED_CANCELLATION = 'Εκκρεμεί αίτημα Ακύρωσης',
    CANCELLED = 'Ακυρωμένη',
    SUBMITTED = 'Σε αναμονή Υποβολής στο Κτηματολόγιο',
    MANUALLY_SUBMITTED = 'Σε αναμονή Υποβολής στο Κτηματολόγιο',
    COMPLETED = 'Υποβλήθηκε',
}
export interface ContractingPeopleTransactionAcceptance {
    notary: {
        afm: string;
        fullname: string;
    };
    buyers: {
        afm: string;
        fullname: string;
    }[];
    sellers: {
        afm: string;
        fullname: string;
    }[];
    userCapacity: string;
    property: {
        address: string;
        atak: string;
    };
}
export interface RequestSummary {
    type: DIALOG_TYPE;
    header?: string;
    actions: DialogAction[];
    body?:
        | {
              image?: any;
              description?: string;
          }
        | {
              label: string;
              classes: string;
          }[];
}

export interface TypeValuePair {
    type: DATA_TABLE_CELL_TYPE;
    value: Array<any> | string;
}
export interface Application {
    action: TypeValuePair;
    applicationStatus: TypeValuePair;
    buyersAfm: TypeValuePair;
    sellersAfm: TypeValuePair;
    documentValidity: TypeValuePair;
    requestNumber: TypeValuePair;
    submissionDate: TypeValuePair;
}
export interface Document {
    action: TypeValuePair;
    documentId: TypeValuePair;
    duration?: string;
    documentCheckedByNotary: TypeValuePair;
    documentTitle: TypeValuePair;
    documentValidityByDuration: TypeValuePair;
    documentValidityDuration: TypeValuePair;
    refreshEnabled: TypeValuePair;
    rowDetails: DataTableRowDetails;
    rowDisabled: boolean;
}
export interface DocumentTableData {
    action: TypeValuePair;
    documentId: TypeValuePair;
    duration?: string;
    documentCheckedByNotary: TypeValuePair;
    documentTitle: TypeValuePair;
    documentValidityByDuration: TypeValuePair;
    documentValidityDuration: TypeValuePair;
    refreshEnabled: TypeValuePair;
    rowDetails: DataTableRowDetails;
    rowDisabled: boolean;
}

export enum DOCUMENT_VALIDITY {
    VALID = 'true',
    INVALID = 'false',
    NOT_CHECKED = 'notChecked',
}

export enum DOCUMENT_VALIDITY_BY_DURATION {
    VALID = 'Ισχυεί',
    EXPIRED = 'Έληξε',
    NOT_CHECKED = 'notChecked',
}

export enum DOCUMENT_STATUS {
    INITIALIZED = '-',
    UPLOAD_NEEDED = 'Απαιτείται μεταφόρτωση',
    WEB_SERVICE_INPUT_NEEDED = '-',
    INPUT_NEEDED = 'Απαιτούνται ενέργειες',
    READY_TO_DOWNLOAD = 'Δεν έχει ανακτηθεί',
    NOT_NEEDED = 'Δεν απαιτείται',
    READY = 'Έχει ανακτηθεί/Μεταφορτωμένο',
    APPROVED = 'Έχει ανακτηθεί/Μεταφορτωμένο',
    DELETED = 'DELETED',
}

export enum DOCUMENT_TITLE {
    ENFIA_CERTIFICATE = 'Πιστοποιητικό ΕΝΦΙΑ',
    MUNICIPALITY_CERTIFICATE = 'Βεβαίωση Δήμου περί μη οφειλής ΤΑΠ',
    AFE_ISSUE_DOCUMENT = 'Αποδεικτικό Φορολογικής Ενημερότητας',
    AKD_REPORT = 'Απόσπασμα Κτηματολογικού Διαγράμματος (Α.Κ.Δ.)',
    DIAGRAM_REPORT = 'Οικοδομική Άδεια και Σχεδιαγράμματα Πολεοδομίας (διάγραμμα κάλυψης, κατόψεις, τοπογραφικό)',
    CIVIL_ENGINEER_CERTIFICATE = 'Πιστοποιητικό Πληρότητας Ταυτότητας Κτιρίου/Διηρημένης Ιδιοκτησίας',
    COMPLETION_CERTIFICATE = 'Βεβαίωση περαίωσης ή οριστικής υπαγωγής της διαδικασίας τακτοποίησης από την οποία προκύπτει ότι έχει εξοφληθεί το πρόστιμο (ολόκληρο ή τουλ. 30%) - άρθρ. 83 ν. 4495/2017',
    ENERGY_EFFICIENCY_CERTIFICATE = 'Πιστοποιητικό ενεργειακού επιθεωρητή για την ενεργειακή απόδοση κτιρίου',
    FLOOR_PLANS = 'Σχέδια (κατόψεις) του μηχανικού όπου αποτυπώνονται οι αυθαιρεσίες σε περίπτωση που αυτές υπάρχουν',
    INSURANCE_CERTIFICATE = 'Αποδεικτικό Ασφαλιστικής Ενημερότητας',
    CONTRACT = 'Τίτλος Κτήσης (max size: 20MBs)',
    PROOF_OF_PAYMENT = 'Αποδεικτικό Εξόφλησης Φόρου Μεταβίβασης Ακινήτου',
    CADASTRAL_DOCUMENTS = 'Οικοδομική Άδεια και Σχεδιαγράμματα Πολεοδομίας (διάγραμμα κάλυψης, κατόψεις, τοπογραφικό)',
    TEEBUILD_DOCUMENTS = 'Έγγραφα Τεχνικού Επιμελητηρίου Ελλάδος (ΤΕΕ)',
    GEMI_CERTIFICATE_OF_REPRESENTATION = 'Πιστοποιητικό ισχύουσας εκπροσώπησης - ΓΕΜΗ',
    GENERAL_GEMI_CERTIFICATE = 'Γενικό Πιστοποιητικό - ΓΕΜΗ',
    DEATH_CERTIFICATE = 'Πιστοποιητικό Ληξιαρχικής Πράξης',
}

export enum DOCUMENT_PUBLIC_SECTOR_OWNER {
  AADE = '<span><a href="https://www.aade.gr/" target="_blank"><img height="80%" width="80%" class="magnifying-glass-title__icon" src="assets/images/logo-aade.svg" alt="logo icon"></a></span>',
  EFKA = '<span><a href="https://www.efka.gov.gr/el" target="_blank"><img height="80%" width="80%" class="magnifying-glass-title__icon" src="assets/images/logo-efka.png" alt="logo icon"></a></span>',
  TEE = '<span><a href="https://web.tee.gr/" target="_blank"><img height="80%" width="80%" class="magnifying-glass-title__icon" src="assets/images/logo-tee.png" alt="logo icon"></a></span>',
  CADASTRE = '<span><a href="https://www.ktimatologio.gr/el" target="_blank"><img height="40%" width="40%" class="magnifying-glass-title__icon" src="assets/images/logo-cadastre.svg" alt="logo icon"></a></span>',
  GEMI = '<span><a href="https://www.businessportal.gr/" target="_blank"><img height="40%" width="40%" class="magnifying-glass-title__icon" src="assets/images/logo-gemi.png" alt="logo icon"></a></span>',
  GOV = '<span><a href="#" target="_blank"><img height="40%" width="40%" class="magnifying-glass-title__icon" src="assets/images/gov-mini-icon.png" alt="logo icon"></a></span>',
  OTHER = '-',
}

export enum USER_ROLE {
    CITIZEN = 'CITIZEN',
    NOTARY = 'NOTARY',
}

export enum USER_CAPACITY {
    BUYER = 'BUYER',
    SELLER = 'SELLER',
    NOTARY = 'NOTARY',
    BACKOFFICER = 'BACKOFFICER',
}

export enum TRANSER_TYPE {
    TRADE = '1',
    DONATION = '2',
    PARENTAL = '3',
    INHERITANCE = '4',
}

export enum SELECT_TABLE_ROW_STATUS {
    SELECTED = 'true',
    NOT_SELECTED = 'false',
    NOT_CHECKED = 'notChecked',
}

export interface DialogAction {
    label: string;
    actionClass: string;
    actionCallback: any;
}

export interface ActionCallbackConfig {
    documentType: string;
    actionCallback: any;
    label: string;
    tip?: string;
    uploadLink?: string;
    class?: string;
}

export interface InputFormStructure {
    value: string;
    representativeAfm: string;
    representativeAfm2: string;
    representativeError: number;
    representativeEmail: string;
    required: boolean;
    type: string;
    submitted: boolean;
    fullName?: string;
    error?: boolean;
    noValidAfm?: boolean;
    individual?: boolean;
    underage?: boolean;
}

export interface InputFormValue {
    afmInput: string;
    representativeAfm: string;
    representativeAfm2: string;
    representativeEmail: string;
}

export interface DataTableConfig {
    headers: DataTableHeader;
    data: DataTableRow[];
    tableClasses?: string;
    rowClickCallback?: any;
    lastColumnLeft?: boolean;
}
export interface DataTableHeader {
    [header: string]: string;
}
export interface DataTableRow {
    rowSelected?: SELECT_TABLE_ROW_STATUS;
    rowDisabled?: boolean;
    rowDetails?: DataTableRowDetails;
    [row: string]:
        | DataTableCell
        | SELECT_TABLE_ROW_STATUS
        | DataTableRowDetails
        | boolean;
}

export interface DataTableCell {
    type: DATA_TABLE_CELL_TYPE;
    value: string | boolean | ButtonConfig[];
}

export interface DataTableRowDetails {
    type: DATA_TABLE_DETAIL_TYPE;
    documentApproved?: boolean;
    templateNumber?: number;
    title?: string;
    desc?: string;
    documentId?: string;
    config?: {
        inputLabel: string;
        inputType: string;
        inputValue?: string | boolean;
        inputFormName?: string;
    }[];
    actions?: ButtonConfig[];
    value?: string;
}

export interface UserInfo {
    firstName?: string;
    lastName?: string;
    companyName?: string;
    taxNumber: string;
    dateOfBirth: string;
    notaryRegId?: string;
    roles: Array<USER_ROLE>;
    selectedRole?: USER_ROLE;
    notaryUniqueId?: string;
    individual?: boolean;
    underage?: boolean;
}

export interface UserState {
    selectedRole: USER_ROLE;
    termsAcceptance: boolean;
    individual: boolean;
    underage: boolean;
}

export interface InfoTableConfig {
    infoTableSectionTitle?: SectionTitleConfig;
    infoTableBackground: InfoTableBackground;
    infoTableData: InfoTableData[];
}

export interface SectionTitleConfig {
    required?: boolean;
    imgPath: string;
    altText: string;
    sectionTitle: string;
}

export interface InfoTableBackground {
    backgroundColor: string;
    rowColor: string;
}

export interface InfoTableData {
    cardHeader?: string;
    headers: InfoTableHeaderRow[] | string[];
    data: InfoTableRow[];
}

export interface InfoTableHeaderRow {
    [header: string]: string;
}

export interface InfoTableRow {
    [row: string]: string;
}

export enum TRANSACTION_INVITATION_STATUS {
    ACCEPTED = 'ACCEPTED',
    REJECTED = 'REJECTED',
    INITIAL = 'INITIAL',
}

export interface TransactionAuthorizationConfig {
    userCapacity: string;
    notary: PersonId;
    sellers: PersonId[];
    buyers: PersonId[];
    property: PropertyId;
}

export interface PersonId {
    firstName?: string;
    lastName?: string;
    fullname?: string;
    afm: string;
}

export interface PropertyId {
    address?: string;
    atak?: string;
}

export interface TabListItem {
    capacity: string;
    fullName: string;
    taxNumber: string;
    addressEstate: string;
    descriptionEstate: string;
    atakNumber: string;
    kaekNumber: string;
    ownerVatId: string;
}

export interface KaekDetails {
  cadOfficeId: number,
  cadOfficeDesc: string;
  street: string;
  streetFrom: string;
  streetTo: string;
  municipality: string;
  zipCode: string;
  locality: string;
  floor: string;
  area: string;
  message: string;
}

export enum DATA_TABLE_CELL_TYPE {
    VALIDITY = 'VALIDITY',
    ACTION = 'ACTION',
    CHECKBOX = 'CHECKBOX',
    REFRESH = 'REFRESH',
    PLAIN_TEXT = 'PLAIN_TEXT',
    WARNING = 'WARNING',
    NOT_SHOWN = 'NOT_SHOWN',
}

export enum DATA_TABLE_DETAIL_TYPE {
    INPUT_FIELD = 'INPUT_FIELD',
    READONLY_LABEL = 'READONLY_LABEL'
}

export enum EXTRA_DOCUMENT_TYPE {
  OTHER = 'Άλλο',
}


export interface ContractingPeopleDetails{
  taxCode: string;
  firstName: string;
  surname : string;
  fatherName: string;
  role ?: string;
}
